__webpack_require__.p = "/game-store-page/";